import { cx } from '@emotion/css';
import { css } from '@emotion/css';

export const GenerateLoading = () => {
  return (
    <>
      <div className="absolute top-0 left-0 right-0 bottom-0 flex items-center justify-center z-10 bg-[var(--fett-bg-elevated)] opacity-40" />
      <div
        className={cx(
          containerCss,
          'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center w-[70px] h-[70px] bg-[var(--fett-bg-elevated)] rounded-lg z-20',
        )}
      >
        <svg width="56" height="56" viewBox="0 0 70 70" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M43.3125 24.5001L10.9375 56.0001C10.9375 56.8751 11.375 57.3127 11.8125 57.3127L15.3125 60.8126C15.75 61.2501 16.1875 61.2502 16.625 61.6877L32.375 45.9376L48.125 30.1876L43.3125 24.5001ZM53.375 26.2501C53.375 26.6876 53.8125 26.6876 53.375 26.2501L53.8125 26.6876H54.6875L63 18.3751C63.875 17.5001 63.875 15.3126 62.125 14.0001L58.625 10.5001C57.3125 9.18765 55.125 8.75015 54.25 9.62515L45.9375 17.9376L45.5 18.3751C45.5 18.8126 45.5 18.8126 45.9375 18.8126L53.375 26.2501Z"
            fill="var(--fett-scenario-accent-text)"
          />
          <path
            className="star-1"
            d="M11.375 36.3125C11.8125 35.875 11.8125 36.3125 11.375 36.3125L13.125 32.8125C13.125 32.375 13.5625 31.9375 14 31.9375L17.0625 30.625V30.1875L14 28.875L13.125 28L11.8125 24.9375H11.375L10.0625 28C10.0625 28.4375 9.625 28.875 9.1875 28.875L6.125 30.1875L9.1875 31.5C9.625 31.5 10.0625 31.9375 10.0625 32.375L11.375 36.3125Z"
            fill="var(--fett-scenario-accent-text)"
            fillOpacity="0.6"
          />
          <path
            className="star-2"
            d="M21.4375 15.3125L25.8125 17.0625C26.25 17.0625 26.25 17.5 26.6875 18.375L28.4375 22.3125H29.3125L31.0625 18.375C31.0625 17.9375 31.5 17.5 31.9375 17.5L35.875 15.75V15.3125V14.875L31.9375 12.6875C31.5 12.6875 31.0625 12.25 31.0625 11.8125L29.3125 7.4375H28.4375L26.6875 11.8125C26.25 12.25 26.25 12.6875 25.375 12.6875L21.4375 14.4375L21 14.875L21.4375 15.3125Z"
            fill="var(--fett-scenario-accent-text)"
            fillOpacity="0.9"
          />
          <path
            className="star-3"
            d="M63.875 52.9375L57.75 50.3125C56.875 49.875 56.4375 49.4375 56 48.5625L53.375 42.875C53.375 42.875 53.375 42.4375 52.9375 42.4375H52.5C52.5 42.4375 52.0625 42.4375 52.0625 42.875L49.4375 48.5625C49 49.4375 48.5625 49.875 48.125 50.3125L42.4375 52.9375H42V53.8125H42.4375L48.125 56.4375C49 56.875 49.4375 57.3125 49.875 58.1875L52.5 63.875C52.5 63.875 52.5 64.3125 52.9375 64.3125H53.375C53.375 64.3125 53.8125 64.3125 53.8125 63.875L56.4375 58.1875C56.875 57.3125 57.3125 56.875 57.75 56.4375L63.4375 53.8125H63.875C64.3125 53.8125 64.3125 53.375 63.875 52.9375C64.3125 53.375 64.3125 53.375 63.875 52.9375Z"
            fill="var(--fett-scenario-accent-text)"
          />
        </svg>
      </div>
    </>
  );
};

const containerCss = css`
  @keyframes starPulse {
    0%,
    100% {
      transform: scale(1);
      opacity: 1;
    }
    50% {
      transform: scale(1.2);
      opacity: 0.4;
    }
  }
  .star-1 {
    animation: starPulse 2s ease-in-out infinite;
    transform-origin: center;
  }
  .star-2 {
    animation: starPulse 2s ease-in-out 0.4s infinite;
    transform-origin: center;
  }
  .star-3 {
    animation: starPulse 2s ease-in-out 0.8s infinite;
    transform-origin: center;
  }
`;
